var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlassian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "atlassian__Integration=Atlassian, Size=24",
    className: "atlassian__Integration=Atlassian, atlassian__Size=24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "atlassian__mask0_26396_241518",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    className: "atlassian__mask0_26396",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atlassian__clip0_459_65346",
    className: "atlassian__clip0_459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atlassian__Vector",
    fill: "#fff",
    d: "M24 0H0v24h24V0Z",
    className: "atlassian__Vector"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#atlassian__mask0_26396_241518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atlassian__Group",
    className: "atlassian__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atlassian__Clip path group",
    className: "atlassian__Clip atlassian__path atlassian__group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "atlassian__mask1_26396_241518",
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    className: "atlassian__mask1_26396",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "atlassian__clip1_459_65346",
    className: "atlassian__clip1_459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atlassian__Vector_2",
    fill: "#fff",
    d: "M20.673 3.342H3.327v17.315h17.346V3.342Z",
    className: "atlassian__Vector"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#atlassian__mask1_26396_241518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atlassian__Group_2",
    className: "atlassian__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atlassian__Vector_3",
    fill: "#1868DB",
    d: "M20.486 19.625 12.547 3.748c-.156-.344-.313-.406-.5-.406-.156 0-.344.062-.531.375-1.126 1.781-1.626 3.844-1.626 6 0 3.001 1.532 5.814 3.782 10.346.25.5.438.594.875.594h5.501c.406 0 .625-.157.625-.469 0-.156-.031-.25-.187-.563Zm-11.533-7.5c-.625-.938-.813-1-.97-1-.155 0-.25.062-.53.624l-3.97 7.939c-.125.25-.156.344-.156.469 0 .25.219.5.688.5h5.594c.375 0 .656-.313.813-.907.187-.75.25-1.406.25-2.187 0-2.188-.97-4.313-1.72-5.439Z",
    className: "atlassian__Vector"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlassian);
export default __webpack_public_path__ + "static/media/Atlassian.8a2732716149b9b849dabb4fac995b13.svg";
export { ForwardRef as ReactComponent };